export const categories = [
  { id: 'latest-movies', name: '最新电影', icon: 'ri-movie-2-line', description: '2024-2025年度最新上映电影资源，第一时间同步更新' },
  { id: 'hot-series', name: '热门剧集', icon: 'ri-tv-2-line', description: '国内外热门电视剧、网剧追剧一站式推荐' },
  { id: 'variety-shows', name: '综艺节目', icon: 'ri-emotion-laugh-line', description: '热门综艺、真人秀、脱口秀节目在线合集' },
  { id: 'documentaries', name: '纪录片', icon: 'ri-earth-line', description: '自然、历史、人文、科技纪录片精品推荐' },
  { id: 'anime', name: '动漫动画', icon: 'ri-rocket-line', description: '日漫、国漫、欧美动画高清在线观看' },
];

export const articles = [
  {
    id: 'best-free-movie-sites-2025',
    title: '2025年最值得收藏的10个免费看片网站推荐',
    excerpt: '经过数月实测，我们从画质清晰度、播放流畅度、资源丰富度、更新速度等多个维度，为你筛选出2025年最值得收藏的10个免费看片网站，让你追剧观影不再发愁。',
    content: `<p>随着流媒体平台越来越多，找到一个真正好用、免费、高清的看片网站反而变得更难了。很多网站广告满天飞、画质模糊、播放卡顿，甚至点进去全是跳转链接。经过数月的实测和对比，我们为你筛选出2025年最值得收藏的10个免费看片网站。</p>
<h2>评测维度说明</h2>
<p>本次评测从以下五个维度进行综合打分：</p>
<ul>
<li><strong>画质清晰度</strong>：是否支持1080P及以上画质</li>
<li><strong>播放流畅度</strong>：视频加载速度和播放卡顿情况</li>
<li><strong>资源丰富度</strong>：电影、剧集、综艺等内容的覆盖范围</li>
<li><strong>更新速度</strong>：新片新剧上线的及时程度</li>
<li><strong>用户体验</strong>：广告数量、界面设计、操作便捷性</li>
</ul>
<h2>TOP 10 推荐列表</h2>
<h3>1. 星辰影院</h3>
<p>资源最全面的看片网站之一，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。支持多条播放线路切换，画质最高可达4K。更新速度非常快，热门新片几乎与院线同步上线。</p>
<h3>2. 蓝光影视</h3>
<p>主打高清蓝光画质，适合追求极致观影体验的用户。站内所有资源均提供1080P及以上画质选项，部分热门影片支持杜比视界。界面简洁清爽，没有过多广告干扰。</p>
<h3>3. 极速看片</h3>
<p>如其名，播放速度极快是这个网站的最大亮点。采用先进的P2P加速技术，即使在网络环境不佳的情况下也能流畅播放。特别适合用手机流量追剧的用户。</p>
<h3>4. 樱花动漫</h3>
<p>动漫爱好者的首选平台，拥有最全的日漫资源库。从经典老番到当季新番一应俱全，字幕翻译质量也非常高。同时支持国漫和欧美动画。</p>
<h3>5. 纪录之家</h3>
<p>专注于纪录片领域的垂直平台，收录了BBC、国家地理、Discovery等知名机构的精品纪录片。涵盖自然、历史、科技、人文等多个类别，是涨知识的好去处。</p>
<h3>6. 追剧达人</h3>
<p>追剧体验最好的看片网站，支持自动连播、断点续看、收藏提醒等功能。剧集分类清晰，可以根据地区、年份、类型快速筛选。更新日历功能让你不错过任何一集。</p>
<h3>7. 经典老片</h3>
<p>怀旧影迷的天堂，收录了从上世纪30年代到2000年的大量经典影片。无论是好莱坞黄金时代的黑白片，还是香港电影的巅峰之作，这里都能找到。</p>
<h3>8. 韩剧天堂</h3>
<p>韩剧爱好者的宝藏网站，韩剧资源最全面、更新最快。提供韩语原声和中文字幕，画质清晰。同时也有韩国电影和综艺节目。</p>
<h3>9. 全能影院</h3>
<p>一站式综合看片平台，电影、电视剧、综艺、动漫、体育赛事直播全覆盖。搜索功能强大，支持模糊搜索和高级筛选。手机端适配做得非常好。</p>
<h3>10. 新世界影视</h3>
<p>新兴的看片网站，界面设计现代美观，交互体验出色。采用智能推荐算法，根据你的观看历史和偏好，精准推荐你可能感兴趣的内容。</p>`,
    category: 'latest-movies',
    author: '影视推荐官',
    date: '2025-01-15',
    readTime: '8分钟',
    imageSeq: 'article-01',
    tags: ['电影推荐', '免费网站', '高清看片', '追剧指南'],
    rating: 4.8,
  },
  {
    id: 'how-to-choose-streaming-site',
    title: '如何选择最适合你的看片网站？新手避坑指南',
    excerpt: '看片网站千千万，但并不是每一个都适合你。本文从安全性、画质、速度、内容偏好等角度，教你如何挑选最适合自己的看片网站，避免踩坑。',
    content: `<p>网上有成千上万个看片网站，但好用的其实并不多。很多新手在寻找看片网站时会遇到各种问题：打开全是广告、视频加载不出来、画质像马赛克、甚至电脑中毒。这篇指南帮你学会如何辨别和选择靠谱的看片网站。</p>
<h2>安全第一：如何识别靠谱网站</h2>
<p>选择看片网站，安全性永远是第一位的。以下是一些安全判断标准：</p>
<ul>
<li>网址是否为HTTPS加密连接</li>
<li>是否强制要求下载播放器或APP</li>
<li>弹窗广告是否过于频繁</li>
<li>是否需要填写个人信息</li>
<li>网站是否运营时间较长、有稳定用户群</li>
</ul>
<h2>根据需求选择类型</h2>
<p>不同类型的看片网站各有侧重，选择适合自己的最重要：</p>
<h3>电影爱好者</h3>
<p>优先选择资源更新快、画质好的综合性看片网站。关注是否支持多线路切换、是否提供1080P以上画质选项。</p>
<h3>追剧达人</h3>
<p>选择支持自动连播、断点续看功能的网站。最好有更新日历和追剧提醒功能，避免错过更新。</p>
<h3>动漫迷</h3>
<p>选择动漫资源专精的垂直平台，关注字幕翻译质量和番剧覆盖完整度。</p>
<h3>纪录片爱好者</h3>
<p>选择BBC、国家地理等正版纪录片资源丰富的平台，画质和内容质量更有保障。</p>`,
    category: 'latest-movies',
    author: '影视推荐官',
    date: '2025-02-20',
    readTime: '6分钟',
    imageSeq: 'article-02',
    tags: ['看片指南', '新手入门', '网站推荐', '安全上网'],
    rating: 4.6,
  },
  {
    id: 'top-korean-drama-sites',
    title: '韩剧迷必收！最全韩剧看片网站合集推荐',
    excerpt: '从《鬼怪》到《黑暗荣耀》，韩剧的魅力席卷全球。本文为韩剧爱好者整理了最专业的韩剧看片网站，让你追剧不迷路。',
    content: `<p>韩剧在全球范围内拥有庞大的粉丝群体。从浪漫爱情到悬疑犯罪，从古装历史到现代职场，韩剧以其精良的制作和扣人心弦的剧情征服了无数观众。我们为韩剧迷整理了最值得收藏的韩剧看片网站。</p>
<h2>韩剧看片网站推荐</h2>
<h3>韩剧天堂</h3>
<p>韩剧资源最全的平台，从经典老剧到最新热播剧一应俱全。提供韩语原声+中文字幕，更新速度极快，新剧播出后几小时内就有中字资源。</p>
<h3>韩流影视</h3>
<p>不仅有韩剧，还涵盖韩国电影、综艺、音乐节目等。界面设计清新，分类清晰，按年份、演员、类型都能快速找到想看的内容。</p>
<h3>追韩剧</h3>
<p>专为韩剧追剧达人打造的平台，提供详细的播出时间表和更新日历。支持收藏和追剧提醒功能，不错过任何一部好剧。</p>
<h2>2025年必看韩剧推荐</h2>
<p>除了找对看片网站，选对好剧同样重要。以下是2025年口碑最佳的几部韩剧，值得一看。</p>`,
    category: 'hot-series',
    author: '影视推荐官',
    date: '2025-03-10',
    readTime: '7分钟',
    imageSeq: 'article-03',
    tags: ['韩剧推荐', '追剧指南', '韩剧网站', '热门剧集'],
    rating: 4.7,
  },
  {
    id: 'anime-streaming-guide',
    title: '动漫迷福音：国内外最佳动漫看片网站大盘点',
    excerpt: '无论你是日漫铁粉、国漫支持者还是欧美动画爱好者，这份动漫看片网站清单都能满足你的需求。从经典老番到当季新番，一网打尽。',
    content: `<p>动漫产业的蓬勃发展让越来越多的优秀作品呈现在我们面前。然而，找到一个资源齐全、更新及时、画质出色的动漫看片网站却并不容易。本文将为你盘点国内外最值得收藏的动漫看片网站。</p>
<h2>日漫专区</h2>
<h3>樱花动漫</h3>
<p>国内最知名的动漫看片网站之一，日漫资源极为丰富。从上世纪经典到最新季度新番，几乎全覆盖。支持多条播放线路，画质清晰稳定。字幕组翻译质量有保障。</p>
<h3>B站追番</h3>
<p>正版番剧资源丰富，弹幕文化增添追番乐趣。虽然是正版平台需要会员，但免费内容同样不少，画质和稳定性是最好的。</p>
<h2>国漫专区</h2>
<h3>国漫之家</h3>
<p>专注于国产动漫的垂直平台，收录了大量优秀的国漫作品。从《斗罗大陆》到《凡人修仙传》，国漫精品尽在其中。</p>
<h2>欧美动画</h2>
<h3>动画世界</h3>
<p>收录了大量迪士尼、皮克斯、梦工厂等知名工作室的动画电影和剧集，适合全年龄段观众。</p>`,
    category: 'anime',
    author: '影视推荐官',
    date: '2025-04-05',
    readTime: '6分钟',
    imageSeq: 'article-04',
    tags: ['动漫推荐', '日漫', '国漫', '看片网站'],
    rating: 4.5,
  },
  {
    id: 'documentary-must-watch',
    title: '涨知识必备！十大顶级纪录片看片网站推荐',
    excerpt: '纪录片是了解世界的最佳窗口。本文精选了十个纪录片资源最丰富的看片网站，涵盖BBC、国家地理等顶级制作机构的精品内容。',
    content: `<p>一部好的纪录片能带你领略世界各地的自然奇观、深入了解人类文明的演进历程、探索科技前沿的奥秘。对于渴望通过影视作品拓宽视野的观众来说，找到优质的纪录片看片网站至关重要。</p>
<h2>综合类纪录片网站</h2>
<h3>纪录之家</h3>
<p>国内最大的纪录片垂直平台，收录了BBC、国家地理、Discovery、NHK等全球顶级制作机构的数千部纪录片。分类涵盖自然、历史、科技、人文、军事等。</p>
<h3>B站纪录片频道</h3>
<p>近年来引进了大量正版纪录片资源，包括BBC Earth、国家地理等品牌的精品内容。弹幕互动也为观看纪录片增添了新的乐趣。</p>
<h2>专业领域纪录片</h2>
<h3>自然之窗</h3>
<p>专注于自然和动物类纪录片，收录了《蓝色星球》《地球脉动》《我们的星球》等经典作品的全部系列。画质以1080P和4K为主。</p>
<h3>历史长廊</h3>
<p>历史类纪录片爱好者的天堂，从古代文明到二战风云，从中国历史到世界通史，内容深度和广度都很出色。</p>`,
    category: 'documentaries',
    author: '影视推荐官',
    date: '2025-05-18',
    readTime: '5分钟',
    imageSeq: 'article-05',
    tags: ['纪录片', 'BBC', '国家地理', '知识科普'],
    rating: 4.9,
  },
  {
    id: 'variety-show-2025',
    title: '2025年最火综艺节目都在哪看？热门综艺看片网站推荐',
    excerpt: '无论是搞笑综艺、音乐竞演还是真人秀，2025年的综艺市场精彩纷呈。我们整理了观看这些热门综艺的最佳看片网站。',
    content: `<p>综艺节目作为茶余饭后的最佳消遣，一直拥有庞大的观众群体。2025年的综艺市场更是百花齐放，各种类型的优质综艺层出不穷。那么，去哪里看这些热门综艺呢？</p>
<h2>热门综艺推荐</h2>
<h3>音乐竞演类</h3>
<p>《歌手2025》《中国好声音》等音乐类综艺持续火爆。这类节目对音质要求较高，建议选择支持高音质播放的看片网站。</p>
<h3>搞笑综艺类</h3>
<p>《脱口秀大会》《一年一度喜剧大赛》等搞笑综艺是放松心情的最佳选择。弹幕互动功能会让观看体验更上一层楼。</p>
<h3>真人秀类</h3>
<p>《奔跑吧》《向往的生活》等真人秀节目经久不衰。建议选择更新速度快、支持多设备同步观看进度的平台。</p>
<h2>综艺看片网站推荐</h2>
<p>全能影院、星辰影院等综合性看片网站都设有专门的综艺频道，资源齐全、更新及时。此外，各大视频平台的正版综艺资源也越来越丰富。</p>`,
    category: 'variety-shows',
    author: '影视推荐官',
    date: '2025-06-22',
    readTime: '5分钟',
    imageSeq: 'article-06',
    tags: ['综艺节目', '真人秀', '音乐竞演', '搞笑综艺'],
    rating: 4.4,
  },
  {
    id: 'mobile-movie-watching-tips',
    title: '手机看片全攻略：最佳移动端看片网站与实用技巧',
    excerpt: '越来越多人习惯用手机看片追剧，但手机看片也有不少坑。本文分享手机看片的最佳网站选择和实用小技巧，让移动观影体验更上一层楼。',
    content: `<p>随着移动互联网的普及，手机已经成为最常用的看片设备。无论是在通勤路上、午休时间还是睡前，掏出手机看一集剧或者一部电影，已经成为很多人的日常。但手机看片也有不少需要注意的地方。</p>
<h2>手机看片网站选择要点</h2>
<ul>
<li><strong>移动端适配</strong>：网站是否针对手机屏幕进行了优化</li>
<li><strong>流量消耗</strong>：是否支持画质调节以节省流量</li>
<li><strong>省电模式</strong>：播放器是否优化了电量消耗</li>
<li><strong>断点续看</strong>：退出后能否记住播放进度</li>
</ul>
<h2>推荐手机友好型看片网站</h2>
<h3>极速看片</h3>
<p>对移动网络优化最好的看片网站，即使在4G网络下也能流畅播放。支持智能码率调节，根据网络状况自动切换画质。</p>
<h3>全能影院</h3>
<p>移动端界面设计最出色的看片网站，操作流畅，适配完美。支持手势控制亮度、音量和进度。</p>`,
    category: 'latest-movies',
    author: '影视推荐官',
    date: '2025-07-08',
    readTime: '5分钟',
    imageSeq: 'article-07',
    tags: ['手机看片', '移动观影', '看片技巧', '实用指南'],
    rating: 4.3,
  },
  {
    id: 'classic-movie-collection',
    title: '经典永不过时！影史百大经典影片看片指南',
    excerpt: '从《肖申克的救赎》到《教父》，从《千与千寻》到《霸王别姬》，经典影片的魅力历久弥新。本文带你找到观看这些经典的最佳渠道。',
    content: `<p>在这个新片层出不穷的时代，经典老片的光芒从未黯淡。一部好的经典影片，无论看多少遍都能给人新的感悟和感动。我们整理了影史百大经典影片的观看指南。</p>
<h2>为什么要看经典影片</h2>
<p>经典影片之所以成为经典，是因为它们超越了时代的局限。无论是叙事技巧、表演艺术还是思想深度，经典影片都能给我们带来独特的审美体验和人生思考。</p>
<h2>经典影片分类推荐</h2>
<h3>好莱坞经典</h3>
<p>《肖申克的救赎》《教父》系列、《阿甘正传》《辛德勒的名单》《飞越疯人院》等，这些影片代表了电影艺术的最高水准。</p>
<h3>华语经典</h3>
<p>《霸王别姬》《活着》《花样年华》《一一》《大话西游》等，华语电影的巅峰之作，每一部都值得反复品味。</p>
<h3>日本经典</h3>
<p>《千与千寻》《七武士》《罗生门》《情书》等，日本电影大师们的传世杰作。</p>
<h2>经典影片观看渠道</h2>
<p>经典老片、B站电影区、各大视频平台的经典影片专区都是不错的选择。部分修复版经典影片支持4K画质，观影体验丝毫不输新片。</p>`,
    category: 'latest-movies',
    author: '影视推荐官',
    date: '2025-07-25',
    readTime: '7分钟',
    imageSeq: 'article-08',
    tags: ['经典电影', '影史百大', '电影推荐', '怀旧'],
    rating: 4.8,
  },
  {
    id: 'free-vs-vip-comparison',
    title: '免费看片网站 vs 付费会员平台：到底哪个更划算？',
    excerpt: '免费看片网站和付费视频会员各有利弊。本文从成本、画质、内容、体验四个维度进行全面对比，帮你做出最适合自己的选择。',
    content: `<p>在追剧看片这件事上，很多人都在纠结：是选择免费看片网站，还是开通视频平台会员？两种方式各有利弊，没有绝对的好坏之分。我们来做一次全面的对比分析。</p>
<h2>成本对比</h2>
<p>免费看片网站当然在成本上占据绝对优势。完全免费，无需任何付费。但需要注意的是，免费网站可能会有广告干扰，部分网站的画质和稳定性不如付费平台。</p>
<p>视频平台会员通常月费在15-30元之间，年费在150-300元左右。如果同时订阅多个平台，成本也不低。</p>
<h2>内容对比</h2>
<p>免费看片网站的内容更加全面，几乎没有版权限制，你可以在一个网站上找到几乎所有想看的影视内容。</p>
<p>付费平台的内容受版权协议限制，不同平台的独家内容各不相同。你可能需要订阅多个平台才能覆盖所有想看的内容。</p>
<h2>体验对比</h2>
<p>付费平台在画质、稳定性、用户体验方面通常更胜一筹。4K HDR、杜比全景声等高级视听体验，目前只有正版平台能够提供。</p>
<p>免费看片网站的体验参差不齐，好的网站体验接近付费平台，差的网站则广告满天飞、画质堪忧。</p>
<h2>结论</h2>
<p>如果你追求极致体验且预算充足，付费平台是最佳选择。如果你希望以最低成本看最全的内容，优质的免费看片网站也是不错的选择。很多人会选择两者结合：重要影片在付费平台观看，一般内容在免费网站解决。</p>`,
    category: 'latest-movies',
    author: '影视推荐官',
    date: '2025-08-01',
    readTime: '6分钟',
    imageSeq: 'article-09',
    tags: ['免费vs付费', '视频会员', '成本分析', '观影指南'],
    rating: 4.5,
  },
];

export const faqs = [
  {
    question: '这些看片网站需要注册吗？',
    answer: '本文推荐的大部分看片网站都无需注册即可直接在线观看。部分网站提供注册功能，注册后可以享受收藏、历史记录、弹幕等额外功能，但不注册也不影响基本的观看体验。',
  },
  {
    question: '看片网站的画质怎么样？支持高清吗？',
    answer: '我们推荐的看片网站大多支持1080P高清画质，部分网站甚至提供4K超高清选项。实际画质取决于具体影片的片源质量，热门新片的画质通常最好。建议在播放器设置中选择最高可用画质以获得最佳观影体验。',
  },
  {
    question: '手机上看片流量消耗大吗？',
    answer: '流量消耗取决于你选择的画质。以一部2小时的电影为例：流畅画质（480P）约消耗500MB，高清画质（720P）约消耗1.5GB，超清画质（1080P）约消耗3GB。建议在Wi-Fi环境下选择高清画质，使用移动数据时切换到流畅模式。',
  },
  {
    question: '看片网站安全吗？会不会有病毒？',
    answer: '我们推荐的看片网站都经过安全检测，页面干净、无恶意弹窗和诱导下载。但请注意：任何要求你下载专用播放器或APP的网站都应警惕；不要点击来路不明的弹窗广告；建议使用广告拦截插件提升浏览安全性。',
  },
  {
    question: '为什么有些影片加载很慢或播放卡顿？',
    answer: '播放卡顿通常有以下原因：网络带宽不足（建议至少10Mbps）、同时在线人数过多导致服务器压力大、你所在地区与服务器距离较远。可以尝试切换到其他播放线路、降低画质、或在非高峰期观看。',
  },
  {
    question: '这些看片网站会一直免费吗？',
    answer: '免费看片网站的运营模式各有不同。大部分网站通过广告收入维持运营，因此能够长期免费提供服务。但也不排除部分网站在运营困难时转型为付费模式。我们建议同时收藏多个备选网站，以防某个网站突然无法访问。',
  },
  {
    question: '看片网站的内容更新速度快吗？',
    answer: '我们推荐的网站更新速度都很快。热门新电影通常在院线下线后1-2周内上线，热门电视剧和综艺一般在播出后数小时内就能看到资源。部分网站还提供更新日历功能，方便你提前了解内容上线时间。',
  },
];

export const aboutInfo = {
  brandName: '看片网精选',
  slogan: '好片不迷路，一站全搞定',
  intro: '看片网精选成立于2023年，是一家专注于影视资源导航与推荐的专业平台。我们的使命是帮助每一位影视爱好者在海量信息中，快速找到最适合自己的看片网站和优质影视内容。',
  story: '创始团队由一群资深影视爱好者和互联网从业者组成。在日常追剧看片的过程中，我们深切体会到寻找靠谱看片网站的不易——广告多、画质差、资源不全、网站频繁更换域名。于是我们决定打造一个专业的看片网站导航平台，通过严格的筛选标准和真实的用户反馈，帮助大家节省时间、提升观影体验。',
  values: [
    { title: '客观公正', description: '所有推荐均基于真实测试和用户口碑，绝不收取网站方的推广费用，确保推荐的公正性。' },
    { title: '持续更新', description: '我们的团队每日跟踪各看片网站的最新状态，及时更新推荐列表，确保信息的时效性。' },
    { title: '用户至上', description: '始终以用户体验为核心，从观看者的真实需求出发，提供最实用的推荐和指南。' },
  ],
  stats: [
    { value: '200+', label: '精选网站' },
    { value: '50万+', label: '月活跃用户' },
    { value: '98%', label: '用户满意度' },
    { value: '3年', label: '持续运营' },
  ],
};

export const siteConfig = {
  name: '看片网精选',
  url: 'https://kandian.example.com',
  description: '看片网站精选推荐——高清免费资源一站直达。寻找优质看片网站？本页精选全网口碑最佳的看片网站，涵盖高清电影、热门剧集、综艺纪录片。',
  foundingDate: '2023-03-15',
  contactEmail: 'contact@kandian.example.com',
};